import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ArmyBuilderConfig } from '../config';
import { HttpClientWithInFlightCache } from '../httpClient';
import { InviteLink } from './models';

@Injectable({ providedIn: 'root' })
export class InviteLinkService {
    private config = inject(ArmyBuilderConfig);
    private http = inject(HttpClientWithInFlightCache);

    private get baseUrl() {
        return `${this.config.apiBaseUrl}/invite-links`;
    }

    getAll(): Observable<InviteLink[]> {
        return this.http.get(`${this.baseUrl}`, { requiresLogin: true });
    }

    create(
        data: { role?: string; feature?: string; label?: string; title?: string; description?: string; redirectUrl?: string }
    ): Observable<InviteLink> {
        return this.http.post(`${this.baseUrl}`, data, { requiresLogin: true });
    }

    setActive(code: string, active: boolean): Observable<InviteLink> {
        return this.http.put(`${this.baseUrl}/${code}`, { active }, { requiresLogin: true });
    }

    delete(code: string): Observable<void> {
        return this.http.delete(`${this.baseUrl}/${code}`, null, { requiresLogin: true });
    }

    getByCode(code: string): Observable<InviteLink> {
        return this.http.get(`${this.baseUrl}/${code}`, { requiresLogin: true });
    }

    redeem(code: string): Observable<InviteLink> {
        return this.http.post(`${this.baseUrl}/${code}/redeem`, {}, { requiresLogin: true });
    }
}
